import React, { useState } from 'react'
import GroceriesService from "../../../services/GroceriesService";

const GroceriesForm = ({ groceryData, groceriesData, setGroceriesData, modalTitle, setIsOpen, addGrocery }) => {

    const {
        name: nameData,
        calories: caloriesData,
        carbohydrates: carbohydratesData,
        proteins: proteinsData,
        fats: fatsData,
        category: categoryData,
        defaultSize: defaultSizeData,
        id: idData,
    } = groceryData;


    const [name, setName] = useState(nameData || '');
    const [calories, setCalories] = useState(caloriesData || '');
    const [carbohydrates, setCarbohydrates] = useState(carbohydratesData || '');
    const [proteins, setProteins] = useState(proteinsData || '');
    const [fats, setFats] = useState(fatsData || '');
    const [category, setCategory] = useState(categoryData || '');
    const [defaultSize, setDefaultSize] = useState(defaultSizeData || '');
    const [id, setId] = useState(idData || '');
    const [hasError, setHasError] = useState(false);


    const formValues = { id, name, calories, carbohydrates, proteins, fats, category, defaultSize };


    const isNullOrWhitespace = value => {
        if (value instanceof String) {
            if (!value || value.trim() === '') {
                return true;
            }
        }

        return false;
    }

    const handleFormSubmit = e => {
        e.preventDefault();
        if (isNullOrWhitespace(name) || isNullOrWhitespace(calories) || isNullOrWhitespace(carbohydrates)
            || isNullOrWhitespace(proteins) || isNullOrWhitespace(fats) || isNullOrWhitespace(category) || isNullOrWhitespace(defaultSize)) {
            setHasError(true);
        } else {
            addGrocery(groceryData, formValues)
            setIsOpen(false);
        }
    }

    return (
        <>
            <h3 className='text-center py-2 bg-bluePrimary text-white shadow-md font-medium '>{modalTitle}</h3>
            <form className="w-full mt-6  px-4">
                <div className="input-group mt-3">
                    <label className="font-medium text-xs text-gray-500">Naziv</label>
                    <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="input-field" />
                    {hasError && isNullOrWhitespace(name) && <span className="input-error">Unesite name.</span>}
                </div>
                <div className="input-group mt-3">
                    <label className="font-medium text-xs text-gray-500">Kalorije</label>
                    <input type="text" value={calories} onChange={(e) => setCalories(e.target.value)} className="input-field" />
                    {hasError && isNullOrWhitespace(calories) && <span className="input-error">Unesite kalorije.</span>}
                </div>
                <div className="input-group mt-3">
                    <label className="font-medium text-xs text-gray-500">Ugljene hidrate</label>
                    <input type="text" value={carbohydrates} onChange={(e) => setCarbohydrates(e.target.value)} className="input-field" />
                    {hasError && isNullOrWhitespace(carbohydrates) && <span className="input-error">Unesite ugljene hidrate.</span>}
                </div>
                <div className="input-group mt-3">
                    <label className="font-medium text-xs text-gray-500">Proteini</label>
                    <input type="text" value={proteins} onChange={(e) => setProteins(e.target.value)} className="input-field" />
                    {hasError && isNullOrWhitespace(proteins) && <span className="input-error">Unesite proteine</span>}
                </div>
                <div className="input-group mt-3">
                    <label className="font-medium text-xs text-gray-500">Masti</label>
                    <input type="text" value={fats} onChange={(e) => setFats(e.target.value)} className="input-field" />
                    {hasError && isNullOrWhitespace(fats) && <span className="input-error">Unesite masti.</span>}
                </div>
                <div className="input-group mt-3">
                    <label className="font-medium text-xs text-gray-500">Kategorija</label>
                    <input type="text" value={category} onChange={(e) => setCategory(e.target.value)} className="input-field" />
                    {hasError && isNullOrWhitespace(category) && <span className="input-error">Unesite kategoriju.</span>}
                </div>
                <div className="input-group mt-3">
                    <label className="font-medium text-xs text-gray-500">Podrazumevana veličina</label>
                    <input type="text" value={defaultSize} onChange={(e) => setDefaultSize(e.target.value)} className="input-field" />
                    {hasError && isNullOrWhitespace(defaultSize) && <span className="input-error">Unesite podrazumevanu veličinu.</span>}
                </div>
                <button type="submit" disabled style={{ display: "none" }} aria-hidden="true"></button>
                <button type="submit" className="button without-icon bg-secondaryGradient mx-auto mt-5" onClick={e => handleFormSubmit(e)}>
                    Sačuvaj
                </button>
            </form>
        </>
    )
}

export default GroceriesForm;
